import React from "react";
import Section from "./common/Section";
import commerce from "../assets/commerce.png";
import research from "../assets/research.png";
import web from "../assets/web.png";
import mobile from "../assets/mobile.png";

const Skill = () => {
  const skills = [
    {
      id: 1,
      image: web,
      title: "FrontEnd",
      subTilte:
        "HTML5, CSS3, Sass, Tailwind CSS, Material UI,JavaScript (ES6+),TypeScript, React, Redux, React Hooks, Bootstrap, Styled Components and Responsive Web Design",
    },
    {
      id: 2,
      image: commerce,
      title: "BackEnd",
      subTilte: "Node JS, Express JS, Laravel and PHP",
    },
    {
      id: 3,
      image: mobile,
      title: "Database",
      subTilte: "MongoDb and MySql",
    },
    {
      id: 4,
      image: research,
      title: "Cloud",
      subTilte:
        "Heroku, Netlify, Vercel, Mongo Atlas and AWS ( Lyamba Functions, Dynamo DB, API Gateway)",
    },
  ];
  return (
    <div>
      <Section title="Skills">
        <div className="grid gap-10 lg:grid-cols-2">
          {skills.map((skill) => (
            <div
              className="flex flex-col items-center jutify-center p-5 shadow-lg dark:shadow-gray-100 rounded-xl duration-300 ease-in-out hover:scale-90 overflow-hidden"
              key={skill.id}
            >
              <img
                src={skill.image}
                alt="img"
                className="w-36 h-36 md:w-44 md:h-44 object-contain"
              />
              <h3 className="mt-5 text-base">{skill.title}</h3>
              <p className="max-w-xl font-light text-gray-500 mb-10 text-sm md:text-base">
                {skill.subTilte}
              </p>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
};

export default Skill;
